import { render } from "./addEditRepairAddress.vue?vue&type=template&id=fdf58faa"
import script from "./addEditRepairAddress.vue?vue&type=script&lang=js"
export * from "./addEditRepairAddress.vue?vue&type=script&lang=js"

import exportComponent from "E:\\源码\\baoxiu\\baoxiu\\VUE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__